export default __webpack_public_path__ + "static/media/god_of.06cb0f25.png";